import { applicationName } from 'expo-application';

import { showErrorToUser } from '@pletly/ui';
import { getPostMutation } from '%screens/posts/new/mutations/postMutations';
import { getSendMessageMutation } from '%components/Messages/mutations/messageMutation';
import { BackgroundService, BackgroundTaskOptions } from '%services/tasks';
import i18n from '../i18n';

export const startPublishPostTask = async (...args: Parameters<typeof getPostMutation>) => {
	const options: BackgroundTaskOptions = {
		...defaultOptions,
		taskName: 'publish-post',
		taskDesc: i18n.t('post.new.your-post-is-being-published'),
	} as const;

	const task = async () => {
		const mutation = getPostMutation(...args);
		try {
			await mutation;
		} catch (error) {
			if (error instanceof Error) {
				showErrorToUser(error);
			}

			console.error(error);
		}
	};

	await BackgroundService.start(task, options);
};

export const startSendMessageTask = async (...args: Parameters<typeof getSendMessageMutation>) => {
	const options: BackgroundTaskOptions = {
		...defaultOptions,
		taskName: 'send-message',
		taskDesc: i18n.t('conversations.sending-private-message'),
	} as const;

	const task = async () => {
		const mutation = getSendMessageMutation(...args);
		try {
			await mutation;
		} catch (error) {
			console.error(error);
		}
	};

	await BackgroundService.start(task, options);
};

const defaultOptions: Omit<BackgroundTaskOptions, 'taskName' | 'taskDesc'> = {
	taskTitle: applicationName || 'Pletly pal',
	taskIcon: {
		name: 'ic_launcher',
		type: 'mipmap',
	},
	progressBar: {
		max: 100,
		value: 0,
		indeterminate: true,
	},
} as const;
